import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';
import expensesReducer from '../reducers/expenses'
import filtersReducer from '../reducers/filters';
import authReducer from '../reducers/auth';
import authfxReducer from '../reducers/authfx'


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__|| compose;

export default () => {
    const store = createStore(
  combineReducers({
    expenses: expensesReducer,
    filters: filtersReducer,
    auth: authReducer,
    authfx: authfxReducer
  }),
  composeEnhancers(applyMiddleware(thunk))
);

return store;
};


// WEBPACK FOOTER //
// ./src/store/configureStore.js